import { useLocation } from 'react-router-dom';
import Footer from './components/Footer';
import Header from './components/Header';
import Router from './routes';


function App() {
  const location = useLocation();

  return (
    <div className="App">
      {!location.pathname.includes('/demo/') && <Header />}
      <Router />
      {!location.pathname.includes('/demo/') && <Footer />}
    </div>
  );
}

export default App;
